import React, { useState } from 'react';
import './DoctorBook.css';

const DoctorBookingPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    gender: '',
    mobile: '',
    email: '',
    areaOfConcern: '',
    concernDescription: '',
    doctorGenderPreference: '',
    languagePreference: '',
    date: '',
    timeSlot: '2:30 PM'
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleGenderPreferenceClick = (preference) => {
    setFormData({
      ...formData,
      doctorGenderPreference: preference
    });
  };

  const handleSubmit = () => {
    console.log('Doctor booking form submitted:', formData);
    alert('Call booked successfully with our psychiatric doctor!');
  };

  return (
    // <div className="main-content">
    //   <div className='main-card'>
      <div className="content-wrapper">
        <div className="header">
          <h1 className="main-title">
            Book a Call with Our Leading<br />
            Psychiatric Doctors.
          </h1>
          <p className="subtitle">
            Simply tell us what you're experiencing. Our system will<br />
            efficiently match you with a certified psychiatrist who can help.
          </p>
        </div>

        <div className="form-container">
          <div className="form-grid">
            {/* Left Column */}
            <div className="left-column">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleInputChange}
                className="input"
              />
              
              <input
                type="number"
                name="age"
                placeholder="Age"
                value={formData.age}
                onChange={handleInputChange}
                className="input"
              />
              
              <select
                name="gender"
                value={formData.gender}
                onChange={handleInputChange}
                className="input"
              >
                <option value="">Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
                <option value="prefer-not-to-say">Prefer not to say</option>
              </select>
              
              <input
                type="tel"
                name="mobile"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleInputChange}
                className="input"
              />
              
              <input
                type="email"
                name="email"
                placeholder="Mail Id"
                value={formData.email}
                onChange={handleInputChange}
                className="input"
              />
            </div>

            {/* Right Column */}
            <div className="right-column">
              <input
                type="text"
                name="areaOfConcern"
                placeholder="Area of Concern (List)"
                value={formData.areaOfConcern}
                onChange={handleInputChange}
                className="input"
              />
              
              <textarea
                name="concernDescription"
                placeholder="Describe more about the Concern"
                value={formData.concernDescription}
                onChange={handleInputChange}
                className="input textarea"
              />
              
              <div className="preference-section">
                <label className="preference-label">Doctor Gender Preference</label>
                <div className="preference-buttons">
                  <button
                    type="button"
                    onClick={() => handleGenderPreferenceClick('M')}
                    className={`preference-button ${formData.doctorGenderPreference === 'M' ? 'preference-button-active' : ''}`}
                  >
                    M
                  </button>
                  <button
                    type="button"
                    onClick={() => handleGenderPreferenceClick('F')}
                    className={`preference-button ${formData.doctorGenderPreference === 'F' ? 'preference-button-active' : ''}`}
                  >
                    F
                  </button>
                  <button
                    type="button"
                    onClick={() => handleGenderPreferenceClick('Any')}
                    className={`preference-button ${formData.doctorGenderPreference === 'Any' ? 'preference-button-active' : ''}`}
                  >
                    Any
                  </button>
                </div>
              </div>
              
              <input
                type="text"
                name="languagePreference"
                placeholder="Language Preference"
                value={formData.languagePreference}
                onChange={handleInputChange}
                className="input"
              />
              
              <div className="date-time-section">
                <div className="date-section">
                  <input
                    type="date"
                    name="date"
                    placeholder="Date"
                    value={formData.date}
                    onChange={handleInputChange}
                    className="date-input"
                  />
                </div>
                <div className="time-section">
                  <label className="time-section-label">Available Slots</label>
                  <div
                    className="time-slot"
                    onClick={() => setFormData({...formData, timeSlot: '2:30 PM'})}
                  >
                    2:30 PM
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="submit-section">
            <button onClick={handleSubmit} className="confirm-button">
              Confirm the Call
            </button>
          </div>
        </div>
      </div>
    //   </div>
    // </div>
  );
};

export default DoctorBookingPage;